<template>
  <TemplateDetailLayout class="content-tab">
    <template #option-heading>
      <AppHeading :text="sectionTitle" tag="h3" />
    </template>
    <template #option-content>
      <!-- title -->
      <div v-if="template.title" class="content-tab__title tab-section">
        <AppHeading text="Título" tag="h4" />
        <p class="content-tab__title-text">{{ template.title }}</p>
      </div>
      <!-- short description -->
      <div v-if="template.short_description" class="content-tab__short-description tab-section">
        <AppHeading text="Descripción corta" tag="h4" />
        <Markdown transitionName="none" :text="template.short_description" />
      </div>
      <!-- description -->
      <div v-if="template.description" class="content-tab__description tab-section">
        <AppHeading text="Descripción" tag="h4" />
        <Markdown transitionName="none" :text="template.description" />
      </div>
      <!-- tasks -->
      <div v-if="template.checklists.length" class="content-tab__tasks tab-section">
        <AppHeading text="Tareas" tag="h4" />
        <Checklists :listing="template.checklists" />
      </div>
    </template>
  </TemplateDetailLayout>
</template>

<script>
// Components
import AppHeading from 'Ui/AppHeading'
import Markdown from 'Modules/Markdown'
import Checklists from 'Modules/Checklists'
import TemplateDetailLayout from 'Layouts/TemplateDetailLayout'

export default {
  name: 'TemplateDetailsPageContent',

  components: {
    Markdown,
    AppHeading,
    Checklists,
    TemplateDetailLayout,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },

    sectionTitle: {
      type: String,
      default: 'Contenido',
    },
  },

  computed: {
    isPrimaryLanguage() {
      return this.language === 'es'
    },
  },
}
</script>

<style scoped>
.tab-section:not(:first-of-type) {
  margin-top: 20px;
}

.content-tab__title-text {
  font-size: 21px;
  font-weight: 600;
  color: var(--rgba--light-blue);
}

.content-tab__short-description-text {
  font-size: 14px;
  color: var(--c-secondary);
  line-height: 30px;
}

.content-tab >>> .checklist__body {
  background-color: transparent;
}
</style>
